// extracted by mini-css-extract-plugin
export const container = "contact-us-module--container--PmApI";
export const main = "contact-us-module--main--19-Au";
export const title = "contact-us-module--title--2QvPW";
export const items = "contact-us-module--items--2rrDT";
export const contactNumber = "contact-us-module--contact-number--Bk1jw";